import styles from "./Loader.module.css";

const Loader = ({ className }) => {
  return <div className={`${styles.loader} ${className}`} />;
};

export default Loader;
